import { graphql } from "@/config/graphql";
import { useQuery } from "@apollo/client";
import { Box, Typography, styled } from "@mui/material";
import { ProductionTable } from "../ProductionReport/components/ProductionTable";
import { BatchControlTable } from "../BatchControlReport/components/BatchControlTable";
import { SuppliesTable } from "../SuppliesReport/components/SuppliesTable";
import { FuelTable } from "../FuelReport/components/FuelTable";
import { TransportationTable } from "../TransportationControlReport/components/TransportationTable";
import { useNavigate, useParams } from "react-router-dom";
import { safeNumber } from "@/utils/number";
import { dateWithoutTimezone, getReadableDate } from "@/utils/date";
import { NavigationContainer } from "@/components/NavigationButton";

const Header = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
  padding-bottom: 16px;
`;
const Body = styled(Box)`
  display: flex;
  gap: 16px;
  flex-direction: column;
  margin-bottom: 60px;
`;

const currentReport = graphql(`
  query currentReport($params: ReportParams!) {
    report(params: $params) {
      id
      date
      comments
      humidity
      noProductionReason
      fuelControlDetails {
        id
        resourceName
        initialHourometer
        finalHourometer
        diesel
        dieselHourometer
        dieselLastHourometer
        hours
        performance
        resourceDetail
        type
        performanceRange {
          min
          max
        }
      }
      supplyDetails {
        id
        resourceName
        resourceId
        initialQuantity
        finalQuantity
        incomeQuantity
        consumedQuantity
        comment
        photoUrl
      }
      productionDetails {
        id
        resource {
          id
          name
        }
        sellQuantity
        destination {
          id
          code
          name
          type
        }
      }
      transportationControlDetails {
        id
        plate
        diesel
        lastOdometer
        chargeOdometer
        kms
        performance
        driver
      }
      batchControlDetails {
        id
        initialHourometer
        finalHourometer
        waste
      }
    }
  }
`);

export const ReportsHistoryDetail = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { data } = useQuery(currentReport, {
    variables: {
      params: {
        id: safeNumber(params.id),
      },
    },
    fetchPolicy: "cache-and-network",
  });
  const goBack = () => {
    navigate("..");
  };
  return (
    <div>
      <Header>
        <Typography variant="h5" fontWeight={800}>
          Reporte{" "}
          {data?.report.date
            ? getReadableDate(dateWithoutTimezone(new Date(data?.report.date)))
            : undefined}
        </Typography>
      </Header>
      <Body>
        <ProductionTable />
        <BatchControlTable />
        <SuppliesTable />
        <FuelTable />
        <TransportationTable />
        <Typography variant="h6">Comentarios</Typography>
        <Typography whiteSpace={"break-spaces"}>
          {data?.report.comments}
        </Typography>
      </Body>

      <NavigationContainer handlePrev={goBack} />
    </div>
  );
};
